import * as Actions from '../actions';
import * as Helpers from '../../TableFilterHelpers';

const initialState = {
    dataList: [],
    filteredDataList: [],
    componentName: '',
    active: false,
    filterColumns: [],
}

const tableFiltertReducer = function (state = initialState, action) {
    switch (action.type) {
        case (Actions.INITIALIZE_FILTER):
            {
                return {
                    ...state,
                    dataList: action.payload.dataList,
                    filteredDataList: Helpers.filterList(action.payload.dataList, action.payload.columns),
                    componentName: action.payload.component,
                    filterColumns: action.payload.columns,
                    active: true
                }
            }
        case (Actions.UPDATE_FILTER_COLUMN):
            // console.log(Helpers.filterList(state.dataList, state.filterColumns))
            {   
                const updatedColumns = state.filterColumns.map(col => {
                    if (col.column_id === action.payload.column) {
                        return {
                            ...col,
                            value: action.payload.value,
                            active: Helpers.checkFilterActive({...col, value: action.payload.value})
                        }
                    }
                    else {
                        return col
                    }
                })

                const updatedFilteredList = Helpers.filterList(state.dataList, updatedColumns)

                return {
                    ...state,
                    filterColumns: updatedColumns,
                    filteredDataList: updatedFilteredList
                }
            }

        case (Actions.CHANGE_ARRAY_SWITCH):
            {
                const updatedColumns = state.filterColumns.map(col => {
                    if (col.column_id === action.payload.column_id) {
                        return {
                            ...col,
                            switchVal: !col.switchVal,
                            active: Helpers.checkFilterActive(col)
                        }
                    }
                    return col
                });

                const updatedFilteredList = Helpers.filterList(state.dataList, updatedColumns)

                return {
                    ...state,
                    filterColumns: updatedColumns,
                    filteredDataList: updatedFilteredList
                }
            }

        case (Actions.CLEAR_FILTER_STORE):
            {
                return {
                    ...initialState
                }
            }

        default:
            {
                return state;
            }

    }
}

export default tableFiltertReducer;


// WEBPACK FOOTER //
// src/main/components/tableFilter/store/reducers/table_filter.reducer.js